module.exports = __webpack_public_path__ + "img/banner2.9b4e4488.jpg";